import { SCREEN } from '../../../../common/selectCurrencyUnit/constant'
import { changeAllowSetDefaultUnit } from '../../../../common/selectCurrencyUnit/slice'
import { COMPANY_TYPES } from '../../../../utils/common'
import { getBankAverageCostThunk } from '../bank/averageCost/store/thunk'
import { getBankBalanceBreakdownThunk } from '../bank/balanceBreakdown/store/thunk'
import { getBankCapitalAndLeverageThunk } from '../bank/capitalAndLeverage/store/thunk'
import { getBankCashBreakdownThunk } from '../bank/cashFlow/store/thunk'
import { getBankDepositAndCreditThunk } from '../bank/depositAndCredit/store/thunk'
import { getBankEarningBreakdownThunk } from '../bank/earningBreakdown/store/thunk'
import { getBankEarningsQualityThunk } from '../bank/earningQuality/store/thunk'
import { getBankFundingStructureThunk } from '../bank/fundingStructure/store/thunk'
import { getBankLiquidityThunk } from '../bank/liquidity/store/thunk'
import { getBankLoanBookBreakdownThunk } from '../bank/loanBookBreakdown/store/thunk'
import { getBankQuickAssessmentThunk } from '../bank/quickAssessment/store/thunk'
import { getAssetManagementEfficiencyThunk } from '../corporate/assetManagementEfficiency/store/thunk'
import { getCorpBalanceBreakdownThunk } from '../corporate/balanceBreakdown/store/thunk'
import { getCorpCashBreakdownThunk } from '../corporate/cashBreakdown/store/thunk'
import { getCorpCoverageThunk } from '../corporate/coverage/store/thunk'
import { getCorpEarningBreakdownThunk } from '../corporate/earningBreakdown/store/thunk'
import { getCorpLiquidityThunk } from '../corporate/liquidity/store/thunk'
import { getProfitabilityThunk } from '../corporate/profitability/store/thunk'
import { getQuickAssessmentCorporateThunk } from '../corporate/quickAssessment/store/thunk'
import { getRoaAndRoeThunk } from '../corporate/roaAndRoe/store/thunk'
import { getCorpSolvencyThunk } from '../corporate/solvency/store/thunk'
import { getLifeInsBalanceBreakdownThunk } from '../lifeInsurance/balanceBreakdown/store/thunk'
import { getLifeInsCashBreakdownThunk } from '../lifeInsurance/cashFlow/store/thunk'
import { getLifeInsEarningBreakdownThunk } from '../lifeInsurance/earningBreakdown/store/thunk'
import { getLifeInsInsurancePremiumRevenueThunk } from '../lifeInsurance/insurancePremiumRevenue/store/thunk'
import { getLifeInsInsuranceSolvencyThunk } from '../lifeInsurance/insuranceSolvency/store/thunk'
import { getLifeInsLiquidityThunk } from '../lifeInsurance/liquidity/store/thunk'
import { getLifeInsOperationalEfficiencyThunk } from '../lifeInsurance/operationalEfficiency/store/thunk'
import { getLifeInsProfitabilityThunk } from '../lifeInsurance/profitability/store/thunk'
import { getLifeInsRoaAndRoeThunk } from '../lifeInsurance/roaAndRoe/store/thunk'
import { getNonBankAverageCostThunk } from '../nonBank/averageCost/store/thunk'
import { getNonBankBalanceBreakdownThunk } from '../nonBank/balanceBreakdown/store/thunk'
import { getNonBankCapitalAndLeverageThunk } from '../nonBank/capitalAndLeverage/store/thunk'
import { getNonBankCashBreakdownThunk } from '../nonBank/cashFlow/store/thunk'
import { getNonBankDepositAndCreditThunk } from '../nonBank/depositAndCredit/store/thunk'
import { getNonBankEarningBreakdownThunk } from '../nonBank/earningBreakdown/store/thunk'
import { getNonBankEarningsQualityThunk } from '../nonBank/earningQuality/store/thunk'
import { getNonBankFundingStructureThunk } from '../nonBank/fundingStructure/store/thunk'
import { getNonBankLiquidityThunk } from '../nonBank/liquidity/store/thunk'
import { getNonBankLoanBookBreakdownThunk } from '../nonBank/loanBookBreakdown/store/thunk'
import { getNonBankQuickAssessmentThunk } from '../nonBank/quickAssessment/store/thunk'
import { getNonLifeInsBalanceBreakdownThunk } from '../nonLifeInsurance/balanceBreakdown/store/thunk'
import { getNonLifeInsCashBreakdownThunk } from '../nonLifeInsurance/cashFlow/store/thunk'
import { getNonLifeInsEarningBreakdownThunk } from '../nonLifeInsurance/earningBreakdown/store/thunk'
import { getNonLifeInsInsurancePremiumRevenueThunk } from '../nonLifeInsurance/insurancePremiumRevenue/store/thunk'
import { getNonLifeInsInsuranceSolvencyThunk } from '../nonLifeInsurance/insuranceSolvency/store/thunk'
import { getNonLifeInsLiquidityThunk } from '../nonLifeInsurance/liquidity/store/thunk'
import { getNonLifeInsOperationalEfficiencyThunk } from '../nonLifeInsurance/operationalEfficiency/store/thunk'
import { getNonLifeInsProfitabilityThunk } from '../nonLifeInsurance/profitability/store/thunk'
import { getNonLifeInsRoaAndRoeThunk } from '../nonLifeInsurance/roaAndRoe/store/thunk'
import { getSecuBalanceBreakdownThunk } from '../security/balanceBreakdown/store/thunk'
import { getSecuBusinessPositionThunk } from '../security/businessPosition/store/thunk'
import { getSecuCashBreakdownThunk } from '../security/cashFlow/store/thunk'
import { getSecuEarningBreakdownThunk } from '../security/earningBreakdown/store/thunk'
import { getSecuEarningQualityThunk } from '../security/earningQuality/store/thunk'
import { getSecuFinancialAssetsThunk } from '../security/financialAsset/store/thunk'
import { getSecuFundingAndLiquidityThunk } from '../security/fundingAndLiquidity/store/thunk'
import { getSecuLeverageThunk } from '../security/leverage/store/thunk'
import { getSecuOperatingIncomeThunk } from '../security/operatingIncome/store/thunk'
import { getHighlightThunk } from '../store/thunk'

const getDataThunk = ({ dispatch, param, companyInfo }) => {
  const dispatchGetHighlight = () =>
    dispatch(
      getHighlightThunk({
        ...param,
        fiscalYearEnd: companyInfo.fiscalYearEnd,
      }),
    )

  const disableAllowSetDefaultUnit = () => {
    dispatch(
      changeAllowSetDefaultUnit({
        screen: SCREEN.FINANCIAL_ANALYSIS,
        value: false,
      }),
    )
  }

  switch (companyInfo.companyType) {
    case COMPANY_TYPES.CORPORATE:
      Promise.all([
        dispatchGetHighlight(),
        dispatch(getProfitabilityThunk(param)),
        dispatch(getQuickAssessmentCorporateThunk(param)),
        dispatch(getRoaAndRoeThunk(param)),
        dispatch(getAssetManagementEfficiencyThunk(param)),
        dispatch(getCorpLiquidityThunk(param)),
        dispatch(getCorpSolvencyThunk(param)),
        dispatch(getCorpCoverageThunk(param)),
        dispatch(getCorpEarningBreakdownThunk(param)),
        dispatch(getCorpBalanceBreakdownThunk(param)),
        dispatch(getCorpCashBreakdownThunk(param)),
      ]).finally(disableAllowSetDefaultUnit)
      break
    case COMPANY_TYPES.BANK:
      Promise.all([
        dispatchGetHighlight(),
        dispatch(getBankQuickAssessmentThunk(param)),
        dispatch(getBankLoanBookBreakdownThunk(param)),
        dispatch(getBankDepositAndCreditThunk(param)),
        dispatch(getBankAverageCostThunk(param)),
        dispatch(getBankEarningsQualityThunk(param)),
        dispatch(getBankCapitalAndLeverageThunk(param)),
        dispatch(getBankLiquidityThunk(param)),
        dispatch(getBankFundingStructureThunk(param)),
        dispatch(getBankEarningBreakdownThunk(param)),
        dispatch(getBankBalanceBreakdownThunk(param)),
        dispatch(getBankCashBreakdownThunk(param)),
      ]).finally(disableAllowSetDefaultUnit)

      break
    case COMPANY_TYPES.NON_BANK:
      Promise.all([
        dispatchGetHighlight(),
        dispatch(getNonBankQuickAssessmentThunk(param)),
        dispatch(getNonBankLoanBookBreakdownThunk(param)),
        dispatch(getNonBankDepositAndCreditThunk(param)),
        dispatch(getNonBankAverageCostThunk(param)),
        dispatch(getNonBankEarningsQualityThunk(param)),
        dispatch(getNonBankCapitalAndLeverageThunk(param)),
        dispatch(getNonBankLiquidityThunk(param)),
        dispatch(getNonBankFundingStructureThunk(param)),
        dispatch(getNonBankEarningBreakdownThunk(param)),
        dispatch(getNonBankBalanceBreakdownThunk(param)),
        dispatch(getNonBankCashBreakdownThunk(param)),
      ]).finally(disableAllowSetDefaultUnit)

      break
    case COMPANY_TYPES.SECURITIES:
      Promise.all([
        dispatchGetHighlight(),
        dispatch(getSecuEarningBreakdownThunk(param)),
        dispatch(getSecuBalanceBreakdownThunk(param)),
        dispatch(getSecuCashBreakdownThunk(param)),
        dispatch(getSecuOperatingIncomeThunk(param)),
        dispatch(getSecuBusinessPositionThunk(param)),
        dispatch(getSecuFinancialAssetsThunk(param)),
        dispatch(getSecuEarningQualityThunk(param)),
        dispatch(getSecuLeverageThunk(param)),
        dispatch(getSecuFundingAndLiquidityThunk(param)),
      ]).finally(disableAllowSetDefaultUnit)

      break
    case COMPANY_TYPES.LIFE_INSURANCE:
      Promise.all([
        dispatchGetHighlight(),
        dispatch(getLifeInsBalanceBreakdownThunk(param)),
        dispatch(getLifeInsInsurancePremiumRevenueThunk(param)),
        dispatch(getLifeInsCashBreakdownThunk(param)),
        dispatch(getLifeInsEarningBreakdownThunk(param)),
        dispatch(getLifeInsInsuranceSolvencyThunk(param)),
        dispatch(getLifeInsLiquidityThunk(param)),
        dispatch(getLifeInsOperationalEfficiencyThunk(param)),
        dispatch(getLifeInsProfitabilityThunk(param)),
        dispatch(getLifeInsRoaAndRoeThunk(param)),
      ]).finally(disableAllowSetDefaultUnit)

      break
    case COMPANY_TYPES.NON_LIFE_INSURANCE:
      Promise.all([
        dispatchGetHighlight(),
        dispatch(getNonLifeInsBalanceBreakdownThunk(param)),
        dispatch(getNonLifeInsInsurancePremiumRevenueThunk(param)),
        dispatch(getNonLifeInsCashBreakdownThunk(param)),
        dispatch(getNonLifeInsEarningBreakdownThunk(param)),
        dispatch(getNonLifeInsInsuranceSolvencyThunk(param)),
        dispatch(getNonLifeInsLiquidityThunk(param)),
        dispatch(getNonLifeInsOperationalEfficiencyThunk(param)),
        dispatch(getNonLifeInsProfitabilityThunk(param)),
        dispatch(getNonLifeInsRoaAndRoeThunk(param)),
      ]).finally(disableAllowSetDefaultUnit)

      break
    default:
      break
  }
}

export default getDataThunk
